module.exports = __webpack_public_path__ + "static/media/Marotte_Noyer_Sepium_MT12-22-Panel.699d7a4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Noyer_Sepium_MT12-22-Panel.jpg
// module id = 961
// module chunks = 37